import { render, staticRenderFns } from "./PricesView.vue?vue&type=template&id=802322cc&"
import script from "./PricesView.vue?vue&type=script&lang=js&"
export * from "./PricesView.vue?vue&type=script&lang=js&"
import style0 from "./PricesView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PricesView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports